import script from "./PolygonStyleUI.vue?vue&type=script&setup=true&lang=js"
export * from "./PolygonStyleUI.vue?vue&type=script&setup=true&lang=js"

import "./PolygonStyleUI.vue?vue&type=style&index=0&id=7fba7966&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fba7966"]])

export default __exports__